import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 21\" id=\"icon-star\"><path d=\"M11.304.34l2.746 6.498 7.03.604c.487.042.685.65.315.97l-5.332 4.62 1.598 6.872a.554.554 0 01-.826.6l-6.04-3.643-6.042 3.643a.554.554 0 01-.826-.6l1.598-6.872-5.333-4.62a.554.554 0 01.316-.971l7.03-.604L10.283.339a.553.553 0 011.02 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol